import { createStore } from 'zustand';
import type { StoreApi } from 'zustand';

import type { Company } from '../../types/companies-data-store';

const initialCompaniesDataStoreState = {
  globalCompaniesState: [],
};

export type CompaniesDataStore = {
  globalCompaniesState: Company[];
  addCompanies: ({ companies }: { companies: Company[] }) => void;
  followCompany: ({ entityPageId }: { entityPageId: string }) => void;
  unfollowCompany: ({ entityPageId }: { entityPageId: string }) => void;
  reset: () => void;
};

export const createCompaniesDataStore = (): StoreApi<CompaniesDataStore> =>
  createStore<CompaniesDataStore>()((set) => ({
    ...initialCompaniesDataStoreState,
    addCompanies: ({ companies }) => {
      set((state) => {
        const newCompanies =
          companies?.filter(
            (newCompany) =>
              !state.globalCompaniesState.some(
                (company) => company?.id === newCompany?.id
              )
          ) ?? [];

        return {
          globalCompaniesState: [
            ...state.globalCompaniesState,
            ...newCompanies,
          ],
        };
      });
    },
    followCompany: ({ entityPageId }) => {
      set((state) => ({
        globalCompaniesState: state.globalCompaniesState.map((company) => {
          if (company.entityPageId === entityPageId) {
            return {
              ...company,
              userContext: {
                followState: {
                  isFollowing: true,
                },
              },
            };
          }

          return company;
        }),
      }));
    },
    unfollowCompany: ({ entityPageId }) => {
      set((state) => ({
        globalCompaniesState: state.globalCompaniesState.map((company) => {
          if (company.entityPageId === entityPageId) {
            return {
              ...company,
              userContext: {
                followState: {
                  isFollowing: false,
                },
              },
            };
          }

          return company;
        }),
      }));
    },
    reset: () => {
      set(initialCompaniesDataStoreState);
    },
  }));

export const companiesDataStore = createCompaniesDataStore();

export const resetCompaniesDataStore = (): void => {
  companiesDataStore.getState().reset();
};
